module.exports = __webpack_public_path__ + "img/bg_view.ab22d956.png";